module.exports = __webpack_public_path__ + "static/media/history_13.4e6f84ac.jpg";